import type { Message } from '@/mocks/app/mockChatData';

/** Escolhas feitas no `ForwardModal` que mudam o conteúdo do encaminhamento. */
export type OpcoesEncaminhamento = {
    /**
     * Legenda escrita no modal, por id de mensagem. Só vale para imagens.
     * Id ausente mantém a legenda original — é o comportamento de sempre, e quem
     * não passa opção nenhuma não muda. Texto vazio (ou só espaços) = sem legenda.
     */
    legendas?: ReadonlyMap<string, string>,
};

/**
 * Mesmo critério do balão (`ChatMessageMedia`): o que o operador enxerga como imagem.
 * Um `file` com mime de imagem aparece como imagem no chat, e a estratégia FILE do
 * encaminhamento também o manda por `/enviar-imagem`.
 */
export function ehImagem(msg: Message): boolean {
    if (msg.type === 'imagem') return true;
    return msg.type === 'file' && !!msg.fileData?.mimeType?.startsWith('image/');
}

/** Só imagens com legenda de verdade ganham o campo de legenda no modal. */
export function ehImagemComLegenda(msg: Message): boolean {
    return ehImagem(msg) && !!msg.fileData?.caption?.trim();
}

/**
 * Legenda que segue no encaminhamento de `msg`. A escolha do modal só vale para
 * imagens: vídeo, documento e áudio continuam levando a legenda original.
 *
 * Texto escrito vai como digitado (igual ao envio de anexo no `FilePreviewModal`).
 * Vazio vira `undefined`, que some do JSON: o payload fica idêntico ao de uma imagem
 * que nunca teve legenda — caminho que todos os provedores já aceitam. Não se manda
 * `''`: string vazia é texto, e o provedor poderia tratá-la como tal.
 */
export function legendaParaEncaminhar(msg: Message, opcoes: OpcoesEncaminhamento = {}): string|undefined {
    const escrita = opcoes.legendas?.get(msg.id);
    if (escrita === undefined || !ehImagem(msg)) return msg.fileData?.caption;
    return escrita.trim() ? escrita : undefined;
}
